import { render, staticRenderFns } from "./setup-totp-dialog.vue?vue&type=template&id=5edc50d0&scoped=true&"
import script from "./setup-totp-dialog.vue?vue&type=script&lang=js&"
export * from "./setup-totp-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edc50d0",
  null
  
)

export default component.exports